import { createAction } from '@reduxjs/toolkit';
import { promoSearchTagsSlice } from './reducer';

export const fetchPromoSearchTags = createAction('promoSearchTags/fetchPromoSearchTags');

export const { clearPromoSearchTags, setPromoSearchTags, setIsFetching } = promoSearchTagsSlice.actions;
